import React, { useCallback } from 'react';
import { IChapterListResponse, IElementListItem, getChapterElementList } from '../api';
import { Iconfont } from '@umu/umu-design';
import { SessionCard } from './sessionCard';
import { LeftIcon } from './leftIcon';
import { useBoolean, useInfiniteScroll } from 'ahooks';
import { lang } from '@umu/ukit-lang';
import { getBool } from '../util';
import _get from 'lodash/get';
import { ObserverIntersectionView } from './observerIntersectionView';
import { components } from 'common';
const { Loading } = components;
interface IChapterProps {
    item: IElementListItem;
    courseInfo?: any;
    groupId: string;
}
export function ChapterCard(props: IChapterProps) {
    const { item, courseInfo, groupId } = props;
    const { chapter_sessions, describe, title, lock, id, chapter_completion: { fold_chapter } } = item;
    const [show, { toggle }] = useBoolean(!Boolean(Number(fold_chapter)));

    const { data, loadMore, noMore, loadingMore } = useInfiniteScroll<IChapterListResponse>(
        (newData: any) => {
            const newPage = Number(_get(newData, 'page_info.current_page', 0)) + 1;
            return getChapterElementList({
                parent_id: groupId,
                size: 20,
                page: newPage,
                key_word: '',
                get_draft: 0,
                chapter_id: id,
            });
        },
        {
            isNoMore: (newData: any) => {
                if (newData && newData.page_info) {
                    const { current_page, total_page_num } = newData.page_info;
                    return current_page >= total_page_num;
                }
                return false;
            },
        },
    );

    const onLastItemDisplay = useCallback(
        (show: boolean) => {
            if (show && !noMore) {
                loadMore();
            }
        },
        [noMore, loadMore],
    );

    const list = data?.list || chapter_sessions.list || [];
    const total = _get(chapter_sessions, 'page_info.list_total_num', 0);

    return (
        <div className="card chapter-card">
            <div onClick={toggle} className="chapter-header-container">
                <div className="chapter-header">
                    <div className="chapter-header-left">
                        <LeftIcon item={item}></LeftIcon>
                        <div className={`title text-truncate-2 ${getBool(lock) ? 'chapter-locked' : ''}`}>
                            {title}
                            <span>（{String(total) + lang('个小节')}）</span>
                        </div>
                    </div>
                    <Iconfont
                        type="RadiusTriangle"
                        style={{
                            transform: show ? 'rotate(0deg)' : 'rotate(-90deg)',
                            transition: 'transform 0.3s',
                        }}
                    ></Iconfont>
                </div>
                {describe && <div className="chapter-desc text-truncate-2">{describe}</div>}
            </div>

            {show ? (
                <div className="session-list">
                    {list.map((session, index) => {
                        const isLastItem = index === list.length - 1;
                        if (isLastItem) {
                            return (
                                <ObserverIntersectionView key={session.element_id} onDisplay={onLastItemDisplay}>
                                    <SessionCard
                                        item={session as IElementListItem}
                                        key={session.element_id}
                                        courseInfo={courseInfo}
                                    />
                                </ObserverIntersectionView>
                            );
                        }
                        return (
                            <SessionCard
                                item={session as IElementListItem}
                                key={session.element_id}
                                courseInfo={courseInfo}
                            />
                        );
                    })}
                    <Loading show={loadingMore} className="loading-more" />
                </div>
            ) : null}
        </div>
    );
}
